<template>
  <div>
    <p class="text-static-default-mid body-2 md:pl-40">
      {{ i18n(translations.sectionTitle) }}
    </p>

    <RecentlyViewedLinks
      :links="recentlyViewedSearchesAndPlps"
      :pending
      @click-link="handleChipClick"
    />

    <ProductFeed
      :pending
      :products="recentlyViewedPdps"
      @click-product="handleProductClick"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import type {
  RecentlyViewedPage,
  RecentlyViewedPlp,
  RecentlyViewedSearch,
} from '../../composables/useRecentlyViewedPages/useRecentlyViewedPages.types'
import { useToggleSearchBar } from '../../composables/useToggleSearchBar'
import ProductFeed from '../ProductFeed/ProductFeed.vue'

import translations from './RecentlyViewedSection.translations'
import RecentlyViewedLinks from './components/RecentlyViewedLinks/RecentlyViewedLinks.vue'

const ENTRY_TYPES: Record<
  RecentlyViewedPage['entryType'],
  'plp_history' | 'query_history' | 'product_history'
> = {
  'search-query': 'query_history',
  plp: 'plp_history',
  pdp: 'product_history',
}

const i18n = useI18n()
const tracking = useTracking()
const { closeSearchBar } = useToggleSearchBar()

const props = defineProps<{
  recentlyViewedPages: RecentlyViewedPage[]
  pending: boolean
}>()

const recentlyViewedSearchesAndPlps = computed(() =>
  props.recentlyViewedPages.filter(
    (page): page is RecentlyViewedSearch | RecentlyViewedPlp =>
      page?.entryType === 'plp' || page?.entryType === 'search-query',
  ),
)

const recentlyViewedPdps = computed(() =>
  props.recentlyViewedPages.filter((page) => page?.entryType === 'pdp'),
)

function handleChipClick(
  link: RecentlyViewedSearch | RecentlyViewedPlp,
  index: number,
) {
  trackHistorySuggestionClick(ENTRY_TYPES[link.entryType], index)
  closeSearchBar()
}

function handleProductClick({ index }: { index: number }) {
  trackHistorySuggestionClick('product_history', index)
  closeSearchBar()
}

function trackHistorySuggestionClick(
  entryType: 'plp_history' | 'query_history' | 'product_history',
  position: number,
) {
  tracking.trackSearchSuggestionClick({
    source: 'history',
    entry_type: entryType,
    position,
  })
}
</script>
